var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Dialog', {
    attrs: {
      "title": "Edit Report",
      "show": _vm.isOpen,
      "onClose": _vm.onClose
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.item,
      "label-width": "120px",
      "label-position": "left",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: _vm.item.name,
      callback: function ($$v) {
        _vm.$set(_vm.item, "name", $$v);
      },
      expression: "item.name"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "KPI",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select...",
      "filterable": "",
      "loading": _vm.loading.kpis,
      "loading-text": "Loading..."
    },
    model: {
      value: _vm.item.kpi,
      callback: function ($$v) {
        _vm.$set(_vm.item, "kpi", $$v);
      },
      expression: "item.kpi"
    }
  }, _vm._l(_vm.kpis, function (_kpi) {
    return _c('el-option', {
      key: _kpi.id,
      attrs: {
        "label": _kpi.name,
        "value": _kpi.id
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Chart type",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select...",
      "disabled": ""
    },
    model: {
      value: _vm.item.chart_type,
      callback: function ($$v) {
        _vm.$set(_vm.item, "chart_type", $$v);
      },
      expression: "item.chart_type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Line",
      "value": "line"
    }
  }), _c('el-option', {
    attrs: {
      "label": "Pie",
      "value": "pie"
    }
  }), _c('el-option', {
    attrs: {
      "label": "Metric",
      "value": "metric"
    }
  })], 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "Color"
    }
  }, [_c('el-color-picker', {
    attrs: {
      "show-alpha": ""
    },
    model: {
      value: _vm.item.border_color,
      callback: function ($$v) {
        _vm.$set(_vm.item, "border_color", $$v);
      },
      expression: "item.border_color"
    }
  })], 1), _c('div', {
    staticClass: "properties-title"
  }, [_c('h3', [_vm._v("Filters")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-plus",
      "round": ""
    },
    on: {
      "click": _vm.addFilter
    }
  }, [_vm._v("Add")])], 1), _vm._l(_vm.item.filters, function (f, index) {
    return _c('el-form-item', {
      key: `f_${index}`,
      attrs: {
        "label": `Property ${index + 1}`
      }
    }, [_c('el-form', {
      attrs: {
        "inline": "",
        "size": "mini",
        "label-position": "top"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Property"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Property",
        "filterable": "",
        "loading": _vm.loading.properties
      },
      model: {
        value: f.property,
        callback: function ($$v) {
          _vm.$set(f, "property", $$v);
        },
        expression: "f.property"
      }
    }, _vm._l(_vm.eventProperties, function (ep) {
      return _c('el-option', {
        key: `f_p_${index}_${ep}`,
        attrs: {
          "label": ep,
          "value": ep
        }
      });
    }), 1)], 1), _c('el-form-item', {
      attrs: {
        "label": "Operator"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Operator"
      },
      model: {
        value: f.operator,
        callback: function ($$v) {
          _vm.$set(f, "operator", $$v);
        },
        expression: "f.operator"
      }
    }, [_c('el-option', {
      attrs: {
        "value": "eq",
        "label": "="
      }
    }), _c('el-option', {
      attrs: {
        "value": "neq",
        "label": "≠"
      }
    })], 1)], 1), _c('el-form-item', {
      attrs: {
        "label": "Value"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Value",
        "disabled": !f.property,
        "filterable": ""
      },
      model: {
        value: f.value,
        callback: function ($$v) {
          _vm.$set(f, "value", $$v);
        },
        expression: "f.value"
      }
    }, _vm._l(_vm.eventPropertyValues(f.property), function (epv) {
      return _c('el-option', {
        key: `f_epv_${index}_${epv}`,
        attrs: {
          "label": epv,
          "value": epv
        }
      });
    }), 1)], 1), _c('el-form-item', {
      attrs: {
        "label": " "
      }
    }, [_c('el-link', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function ($event) {
          return _vm.removeProperty(_vm.item.filters, index);
        }
      }
    }, [_vm._v("Remove")])], 1)], 1)], 1);
  }), _c('div', {
    staticClass: "properties-title"
  }, [_c('h3', [_vm._v("Breakdown")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-plus",
      "round": ""
    },
    on: {
      "click": _vm.addBreakdown
    }
  }, [_vm._v("Add")])], 1), _vm._l(_vm.item.breakdown, function (b, index) {
    return _c('el-form-item', {
      key: `b_${index}`,
      attrs: {
        "label": `Property ${index + 1}`
      }
    }, [_c('el-form', {
      attrs: {
        "inline": "",
        "size": "mini",
        "label-position": "top"
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "Label"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Label"
      },
      model: {
        value: b.label,
        callback: function ($$v) {
          _vm.$set(b, "label", $$v);
        },
        expression: "b.label"
      }
    })], 1), _c('el-form-item', {
      attrs: {
        "label": "Property"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Property",
        "filterable": "",
        "loading": _vm.loading.properties
      },
      model: {
        value: b.property,
        callback: function ($$v) {
          _vm.$set(b, "property", $$v);
        },
        expression: "b.property"
      }
    }, _vm._l(_vm.eventProperties, function (ep) {
      return _c('el-option', {
        key: `b_p_${index}_${ep}`,
        attrs: {
          "label": ep,
          "value": ep
        }
      });
    }), 1)], 1), _c('el-form-item', {
      attrs: {
        "label": "Operator"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Operator"
      },
      model: {
        value: b.operator,
        callback: function ($$v) {
          _vm.$set(b, "operator", $$v);
        },
        expression: "b.operator"
      }
    }, [_c('el-option', {
      attrs: {
        "value": "eq",
        "label": "="
      }
    }), _c('el-option', {
      attrs: {
        "value": "neq",
        "label": "≠"
      }
    })], 1)], 1), _c('el-form-item', {
      attrs: {
        "label": "Value"
      }
    }, [_c('el-select', {
      attrs: {
        "placeholder": "Value",
        "disabled": !b.property,
        "filterable": ""
      },
      model: {
        value: b.value,
        callback: function ($$v) {
          _vm.$set(b, "value", $$v);
        },
        expression: "b.value"
      }
    }, _vm._l(_vm.eventPropertyValues(b.property), function (epv) {
      return _c('el-option', {
        key: `b_epv_${index}_${epv}`,
        attrs: {
          "label": epv,
          "value": epv
        }
      });
    }), 1)], 1), _c('el-form-item', {
      attrs: {
        "label": "Color"
      }
    }, [_c('el-color-picker', {
      attrs: {
        "show-alpha": ""
      },
      model: {
        value: b.border_color,
        callback: function ($$v) {
          _vm.$set(b, "border_color", $$v);
        },
        expression: "b.border_color"
      }
    })], 1), _c('el-form-item', {
      attrs: {
        "label": " "
      }
    }, [_c('el-link', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function ($event) {
          return _vm.removeProperty(_vm.item.breakdown, index);
        }
      }
    }, [_vm._v("Remove")])], 1)], 1)], 1);
  }), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.item.id ? 'Save' : 'Create'))]), _c('el-button', {
    on: {
      "click": function ($event) {
        return _vm.onClose();
      }
    }
  }, [_vm._v("Cancel")])], 1)], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }